// import React, { useEffect, useState, useRef } from "react";
// import "./Login.css";
// import axiosConfig from "../../Service/axiosConfig";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { addWishlist } from "../../redux/Slices/cartSlice";

// const Login = ({
//   handleLoginEvent,
//   setNumber,
//   number,
//   SetStep,
//   Step,
//   Setlogin,
//   LoginAccount,
// }) => {
//   let navigate = useNavigate();
//   const [userId, setUserId] = useState();
//   const [timeLeft, setTimeLeft] = useState(30);
//   const [isExpired, setIsExpired] = useState(false);
//   const [Data, SetData] = useState({
//     mobile: "",
//     otp: "",
//   });
//   const [otps, setOtps] = useState([
//     { id: 1, value: "" },
//     { id: 2, value: "" },
//     { id: 3, value: "" },
//     { id: 4, value: "" },
//   ]);
//   const isSubmitDisabled = !otps.every((otp) => otp.value);
//   const [error, SetError] = useState("");
//   const InputHandleer = (e) => {
//     const name = e.target.name;
//     const value = e.target.value;
//     SetData({ ...Data, [name]: value });
//   };

//   const inputRefs = useRef([]);

//   const handleChange = (e, id) => {
//     const { value } = e.target;

//     if (/^\d?$/.test(value)) {
//       setOtps((prev) =>
//         prev.map((otp) =>
//           otp.id === id ? { ...otp, value } : otp
//         )
//       );

//       // Move focus forward
//       const index = id - 1;
//       if (value && index < otps.length - 1) {
//         inputRefs.current[index + 1].focus();
//       }
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const otpValues = otps.map((otp) => otp.value).join("");
//     console.log("OTP Submitted: ", otpValues);
//     // You can now use otpValues for verification
//   };
//   const [loginSuccess, SetloginSuccess] = useState(false);
//   const ValidateMobile = (e) => {
//     e.preventDefault();
//     setNumber({ ...number, mobile: Data.mobile });
//     SetError(""); // Clear error before validation
//     if (Data.mobile.length < 10 || Data.mobile.length > 10) {
//       SetError("Enter A Valid Mobile number");
//     } else {
//       let domain = window.location.hostname.replace("www.", "");
//       axiosConfig
//         .post("/accounts/validate_contact/", {
//           mobile: Data.mobile,
//           verify_domain: domain === "localhost" ? "medeaz.taprootcrm.com" : domain,
//         })
//         .then((res) => {
//           SetStep(2);
//           console.log(res.data.message);
//           SetError("");
//           setTimeLeft(30);
//           setOtps([
//             { id: 1, value: "" },
//             { id: 2, value: "" },
//             { id: 3, value: "" },
//             { id: 4, value: "" },
//           ]);
//         })
//         .catch((e) => {
//           console.log(e);
//         });
//     }
//   };
//   useEffect(() => {
//     if (timeLeft > 0) {
//       const timerId = setInterval(() => {
//         setTimeLeft((prevTime) => prevTime - 1);
//       }, 1000);
//       return () => clearInterval(timerId);
//     } else {
//       setIsExpired(true);
//     }
//   }, [timeLeft]);

//   const handleResendClick = (e) => {
//     ValidateMobile(e);
//     setTimeLeft(30);
//     setIsExpired(false);
//   };
//   const VerifyOtp = (e) => {
//     e.preventDefault();
//     axiosConfig
//       .post("/accounts/verify_otp/", {
//         mobile: Data.mobile,
//         otp: otps.map((otp) => otp.value).join(""),
//       })
//       .then((res) => {
//         console.log(res, "otp posted");
//         localStorage.setItem("token", res.data.token);
//         localStorage.setItem("userId", res.data.user_id);
//         setUserId(res.data.user_id);
//         GetData(res.data.user_id);
//         // localStorage.setItem('wishlists', JSON.stringify(res.data.results));
//         localStorage.setItem("number", Data.mobile);
//         SetloginSuccess(true);
//         handleLoginEvent();
//         Setlogin && Setlogin(!LoginAccount);
//       })
//       .catch((e) => {
//         console.log(e);
//         if (e.response.data.message === "Verification failed.") {
//           SetError("Invalid OTP. Please try again.");
//         }
//       });
//   };
//   let page = 1;
//   const dispatch = useDispatch();
//   // const[isDeleted,setIsDeleted]=useState(false)
//   const GetData = async (user) => {
//     console.log("inside get data");
//     try {
//       const response = await axiosConfig.get(
//         `/catlog/wishlists/?page_size=20&page=${page}&user=${user}`
//       );
//       console.log(response.data.results);
//       response.data.results.map((item) => {
//         dispatch(addWishlist({ productId: item.product.id, wish_id: item.id }));
//       });
//       // setIsDeleted(false)
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   // useEffect(() => {
//   //     userId && GetData(userId);
//   // },[isDeleted, userId])
//   const handleKeyDown = (e, index) => {
//     if (e.key === "Backspace") {
//       setOtps((prevOtps) =>
//         prevOtps.map((otp, i) =>
//           i === index ? { ...otp, value: "" } : otp
//         )
//       );

//       // Move focus to previous input
//       if (index > 0) {
//         inputRefs.current[index - 1].focus();
//       }
//     }
//   };

//   return (
//     <>
//       {loginSuccess ? (
//         <>
//           <h4 className="login-success">Login Successful</h4>
//         </>
//       ) : (
//         <>
//           {Step == "1" ? (
//             <form className="login-form">
//               {/* <p className="">Enter your phone number to </p>
//                             <p className="">Login/Sign up</p> */}
//               <div className="login-header-main">
//                 <div className="login-help weight--semibold">
//                   Enter your phone number to
//                 </div>
//                 <div className="login-help weight--semibold">Login/Sign up</div>
//               </div>
//               <div className="form-group input-prefix">
//                 <span className="prefix me-2">+91</span>
//                 <input
//                   name="mobile"
//                   className="num-input"
//                   type="tel"
//                   inputMode="numeric"
//                   pattern="[0-9]*"
//                   placeholder="Mobile Number"
//                   value={Data.mobile}
//                   onChange={InputHandleer}
//                   onWheel={(e) => e.target.blur()}
//                   maxLength={10}
//                   style={{ flex: 1 }}
//                 />
//                 {/* <div className="color-error">{error && error}</div> */}
//               </div>

//               <button
//                 type="submit"
//                 className="btn btn-next"
//                 disabled={Data.mobile.length !== 10}
//                 onClick={ValidateMobile}
//               >
//                 Next
//               </button>
//             </form>
//           ) : (
//             <form className="otp-form">
//               <p className="">Enter 4 digit code sent to your phone</p>
//               <p>+91-{Data.mobile}</p>
//               <div className="fullCentered mb-3">
//                 {otps.map((otp, index) => (
//                   <input

//                     type="tel"
//                     inputMode="numeric"
//                     pattern="[0-9]*"
//                     key={otp.id}
//                     ref={(el) => (inputRefs.current[index] = el)} // Assigning ref to each input
//                     name={`otp-${otp.id}`}
//                     className="form-control otp-input"
//                     maxLength={1}
//                     value={otp.value}
//                     onChange={(e) => handleChange(e, otp.id)}
//                     onKeyDown={(e) => handleKeyDown(e, index)}
//                     autoFocus={index === 0}
//                   />
//                 ))}
//               </div>
//               <div className="color-error">{error && error}</div>
//               <button
//                 type="submit"
//                 className="btn btn-next"
//                 disabled={isSubmitDisabled}
//                 onClick={VerifyOtp}
//               >
//                 Submit
//               </button>
//               <div
//                 style={{
//                   fontFamily: "Arial, sans-serif",
//                   fontSize: "20px",
//                   margin: "20px",
//                 }}
//               >
//                 {!isExpired ? (
//                   <span>Resend OTP in {timeLeft} sec</span>
//                 ) : (
//                   <span
//                     onClick={handleResendClick}
//                     style={{
//                       textDecoration: "underline",
//                       cursor: "pointer",
//                       color: "var(--primary_color)",
//                     }}
//                   >
//                     ResendOTP
//                   </span>
//                 )}
//               </div>
//             </form>
//           )}
//         </>
//       )}
//     </>
//   );
// };
// export { Login };

import React, { useEffect, useState, useRef } from "react";
import "./Login.css";
import axiosConfig from "../../Service/axiosConfig";
import { useDispatch } from "react-redux";
import { addWishlist } from "../../redux/Slices/cartSlice";
import CountryCodeSelect from "../../../../Utils/CountryCodeSelect";
import { getCountryPhoneConfig, validateCountryPhoneNumber } from "../../../../Utils/countries";

const Login = ({
  handleLoginEvent,
  setNumber,
  number,
  SetStep,
  Step,
  Setlogin,
  LoginAccount,
}) => {

  const dispatch = useDispatch();

  const [userId, setUserId] = useState();
  const [timeLeft, setTimeLeft] = useState(30);
  const [isExpired, setIsExpired] = useState(false);

  const [Data, SetData] = useState({
    contact: "",
  });

  const [countryCode, setCountryCode] = useState("+1");
  const [contactType, setContactType] = useState("");

  const phoneConfig = getCountryPhoneConfig(countryCode);

  const [otps, setOtps] = useState([
    { id: 1, value: "" },
    { id: 2, value: "" },
    { id: 3, value: "" },
    { id: 4, value: "" },
    { id: 5, value: "" },
    { id: 6, value: "" },
  ]);

  const [error, SetError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginSuccess, SetloginSuccess] = useState(false);
  const [agree, setAgree] = useState(false);
  const [clientName, setClientName] = useState("RentExcel");

  useEffect(() => {
    const fetchSiteData = async () => {
      try {
        const res = await axiosConfig.get("/sitedata/site-config/");
        if (res?.data?.tenant?.company_name) {
          setClientName(res.data.tenant.company_name);
        }
      } catch (err) {
        console.warn("Failed to fetch site config for client name", err);
      }
    };
    fetchSiteData();
  }, []);

  const inputRefs = useRef([]);

  const isSubmitDisabled = !otps.every((otp) => otp.value);

  // const InputHandleer = (e) => {
  //   const value = e.target.value.replace(/\D/g,"").slice(0,10)

  //   if (/^\d*$/.test(value)) {
  //     if (value.length <= 10) {
  //       SetData({ ...Data, contact: value });
  //     }
  //   } else {
  //     SetData({ ...Data, contact: value });
  //   }

  //   SetError("");
  // };
  const InputHandleer = (e) => {
    const value = e.target.value;

    // Empty input
    if (!value) {
      SetData({ ...Data, contact: "" });
      SetError("");
      return;
    }

    // Starts with a digit → Mobile mode
    if (/^\d/.test(value)) {
      SetData({
        ...Data,
        contact: value.replace(/\D/g, "").slice(0, phoneConfig.maxLength),
      });
    }
    // Starts with a letter → Email mode
    else {
      SetData({
        ...Data,
        contact: value,
      });
    }

    SetError("");
  };
  const handleChange = (e, id) => {
    const { value } = e.target;

    if (/^\d?$/.test(value)) {
      setOtps((prev) =>
        prev.map((otp) =>
          otp.id === id ? { ...otp, value } : otp
        )
      );

      const index = id - 1;

      if (value && index < otps.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      setOtps((prevOtps) =>
        prevOtps.map((otp, i) =>
          i === index ? { ...otp, value: "" } : otp
        )
      );

      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const ValidateMobile = async (e) => {
    e.preventDefault();

    if (!agree) return;

    const trimmed = Data.contact.trim();
    setNumber?.({ contact: trimmed, mobile: trimmed, country_code: countryCode });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isNumericOnly = /^\d+$/.test(trimmed);

    SetError("");

    if (!trimmed) {
      SetError("Please enter mobile number or email");
      return;
    }

    if (isNumericOnly) {
      const phoneError = validateCountryPhoneNumber(trimmed, countryCode);
      if (phoneError) {
        SetError(phoneError);
        return;
      }
      setContactType("mobile");
    } else {
      if (emailRegex.test(trimmed)) {
        setContactType("email");
      } else {
        SetError("Enter valid email");
        return;
      }
    }

    setLoading(true);

    try {
      const formattedContact = trimmed;

      const res = await axiosConfig.post(
        "/accounts/validate_contact/",
        {
          contact: formattedContact,
          role: "Customer",
          country_code: countryCode || "+1",
        }
      );

      console.log(res.data);

      SetStep(2);

      setTimeLeft(30);
      setIsExpired(false);

      setOtps([
        { id: 1, value: "" },
        { id: 2, value: "" },
        { id: 3, value: "" },
        { id: 4, value: "" },
        { id: 5, value: "" },
        { id: 6, value: "" },
      ]);

    } catch (e) {
      console.log(e);

      SetError(
        e.response?.data?.error ||
        "Failed to send OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (timeLeft > 0 && Step === 2) {
      const timerId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timerId);
    } else {
      setIsExpired(true);
    }
  }, [timeLeft, Step]);

  const handleResendClick = async (e) => {
    ValidateMobile(e);
    setTimeLeft(30);
    setIsExpired(false);
  };

  const VerifyOtp = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      const otpValue = otps
        .map((otp) => otp.value)
        .join("");

      const trimmedContact = Data.contact.trim();
      const formattedContact = trimmedContact;

      const res = await axiosConfig.post(
        "/accounts/verify_otp/",
        {
          contact: formattedContact,
          otp: otpValue,
          country_code: countryCode || "+1",
        }
      );

      console.log(res.data);

      localStorage.setItem(
        "token",
        res.data.token
      );

      localStorage.setItem(
        "userId",
        res.data.user_id
      );
      localStorage.setItem(
        "userid",
        res.data.user_id
      );

      localStorage.setItem(
        "number",
        Data.contact
      );

      if (res.data.name) {
        localStorage.setItem(
          "name",
          res.data.name
        );
      }

      setUserId(res.data.user_id);

      GetData(res.data.user_id);

      SetloginSuccess(true);

      handleLoginEvent();

      Setlogin &&
        Setlogin(!LoginAccount);

    } catch (e) {

      console.log(e);

      SetError(
        e.response?.data?.message ||
        "Invalid OTP"
      );

    } finally {
      setLoading(false);
    }
  };

  let page = 1;

  const GetData = async (user) => {

    try {

      const response = await axiosConfig.get(
        `/catlog/wishlists/?page_size=20&page=${page}&user=${user}`
      );

      response.data.results.map((item) => {
        const wishlistProduct = item.varient || item.product;
        if (!wishlistProduct?.id) return null;
        dispatch(
          addWishlist({
            productId: wishlistProduct.id,
            wish_id: item.id,
          })
        );
        return null;
      });

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {loginSuccess ? (
        <>
          <h4 className="login-success">
            Login Successful
          </h4>
        </>
      ) : (
        <>
          {Step == "1" ? (
            <form className="login-form">

              <div className="login-header-main">
                <div className="login-help weight--semibold">
                  Enter your mobile number or email
                </div>

                <div className="login-help weight--semibold">
                  to Login/Sign up
                </div>
              </div>

              <div className="form-group input-prefix" style={{ display: "flex", alignItems: "center" }}>
                <CountryCodeSelect
                  value={countryCode}
                  onChange={(dialCode) => {
                    setCountryCode(dialCode);
                    const nextConfig = getCountryPhoneConfig(dialCode);
                    if (/^\d/.test(Data.contact)) {
                      SetData((prev) => ({
                        ...prev,
                        contact: prev.contact.slice(0, nextConfig.maxLength),
                      }));
                    }
                  }}
                  buttonStyle={{
                    border: "none",
                    boxShadow: "none",
                    padding: "0 8px 0 0",
                    minHeight: "auto",
                    height: "auto",
                    background: "transparent",
                  }}
                />

                <input
                  className="num-input"
                  type="text"
                  placeholder={phoneConfig.placeholder ? `${phoneConfig.placeholder} / Email` : "Mobile Number / Email"}
                  value={Data.contact}
                  onChange={InputHandleer}
                  style={{ flex: 1 }}
                />
              </div>

              <div className="color-error">
                {error && error}
              </div>

              <button
                type="submit"
                className="btn btn-next"
                onClick={ValidateMobile}
                disabled={loading || !agree}
              >
                {loading ? "Please Wait..." : "Next"}
              </button> 
              <div className="mt-3" style={{ fontSize: "12px", color: "#6c757d", width: "100%", display: "flex", alignItems: "flex-start", gap: "10px", textAlign: "left" }}>
                <input type="checkbox" id="agreeCheckbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} style={{ marginTop: "2px", cursor: "pointer", width: "16px", height: "16px", flexShrink: 0 }} />
                <label
                  htmlFor="agreeCheckbox"
                  style={{ cursor: "pointer", margin: 0, lineHeight: "1.4" }}
                >
                  By checking this box, you consent to receive SMS text messages from{" "}
                  {clientName} for account verification, login authentication, and security
                  notifications. Message frequency varies. Msg & data rates may apply.
                  Reply STOP to cancel, HELP for help. Consent is not a condition of
                  purchase or use. See our{" "}
                  <a
                    href="/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>{" "}
                  and{" "}
                  <a
                    href="/terms-of-service"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Use
                  </a>
                  .
                </label>
              </div>
            </form>
          ) : (
            <form className="otp-form">

              <p>
                Enter 6 digit code sent to your{" "}
                {contactType === "mobile"
                  ? "phone"
                  : "email"}
              </p>

              <p>{contactType === "mobile" ? `${countryCode} ${Data.contact}` : Data.contact}</p>

              <div className="fullCentered mb-3">
                {otps.map((otp, index) => (
                  <input
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    key={otp.id}
                    ref={(el) =>
                      (inputRefs.current[index] = el)
                    }
                    className="form-control otp-input"
                    maxLength={1}
                    value={otp.value}
                    onChange={(e) =>
                      handleChange(e, otp.id)
                    }
                    onKeyDown={(e) =>
                      handleKeyDown(e, index)
                    }
                    autoFocus={index === 0}
                  />
                ))}
              </div>

              <div className="color-error">
                {error && error}
              </div>

              <button
                type="submit"
                className="btn btn-submit"
                disabled={isSubmitDisabled || loading}
                onClick={VerifyOtp}
              >
                {loading ? "Verifying..." : "Submit"}
              </button>

              <div
                style={{
                  fontFamily: "Arial, sans-serif",
                  fontSize: "20px",
                  margin: "20px",
                }}
              >
                {!isExpired ? (
                  <span>
                    Resend OTP in {timeLeft} sec
                  </span>
                ) : (
                  <span
                    onClick={handleResendClick}
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: "#735ceb",
                    }}
                  >
                    Resend OTP
                  </span>
                )}
              </div>
            </form>
          )}
        </>
      )}
    </>
  );
};

export { Login };
